import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    padding: '18px',
    boxShadow: '0px 1.88px 22.58px 0px #00000014',
  },
  subContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardDigitContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: 'grey.800',
    mb: '12px',
  },
  cardDetailContainer: {
    marginLeft: '24px',
  },
  cardType: {
    fontSize: 16,
    fontWeight: '500',
    color: 'grey.800',
    textTransform: 'capitalize',
    mb: '8px',
  },
  lastDigits: {
    fontSize: 14,
    color: 'grey.600',
  },
  button: {
    padding: 0,
    margin: 0,
    alignSelf: 'flex-end',
  },
  link: {
    color: 'primary.main',
    textDecoration: 'underline',
    fontSize: 14,
    fontWeight: '500',
  },
  removeBorder: { border: 'none' },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
